export enum SizeMode {
  Standard = 'standard',
  Customer = 'customer',
  Custom = 'custom',
}
